import Data from "../Data";
import "../Taketour.css";
import StyleItem from "../StyleItem";
import heroTimesheet from "../../../../assets/images/hero-timesheets.png"

const Timesheet = () => {
    const { timesheetData } = Data();
    return (
        <div>
            {timesheetData.map((item, index) => (
                <StyleItem key={index} data={item} />
            ))}
            <div className="taketour-image-section">
                <img src={heroTimesheet} alt="" />
            </div>
        </div>
    )
}

export default Timesheet
